export const setCookieCompanyId = (cookies, companyId) => {
  cookies.set('companyId', companyId, { path: '/' });
}

export const getCookieCompanyId = (cookies) => {
  return cookies.get('companyId')
}


// WEBPACK FOOTER //
// ./src/services/cookies.services.js